import React, { PureComponent } from 'react'
import { string, bool } from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import AuthActions from 'store/redux/auth'
import { translate } from 'react-i18next'
import { Text } from 'components'
import './StatusBar.css'

@connect(
    null,
    {
        navigate: push,
        signout: AuthActions.signout
    }
)
@translate()
export class McNavBar extends PureComponent {
    static propTypes = {
        title: string.isRequired,
        backRoute: string,
        withSignout: bool,
    }
    static defaultProps = {
        backRoute: undefined,
        withSignout: false,
    }
    render() {
        const {
            title,
            backRoute,
            withSignout,
            navigate,
            signout,
            t
        } = this.props
        return (
            <div className="StatusBar McNavBar">
                <div className="StatusBar-Content flex row-stretch-center">
                    <div className="flex flex-grow row-stretch-center">
                        <div className="flex row-left-center">
                            {backRoute && <a onClick={() => navigate(backRoute)}>{t('mc.navbar.back')}</a>}
                        </div>
                        <div className="flex row-center">
                            <Text className="StatusBar-GameCode-Title">{title}</Text>
                        </div>
                        <div className="flex row-right-bottom">
                            {withSignout && <a onClick={signout}>{t('mc.navbar.signout')}</a>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/StatusBar/McNavBar.js